<div class="visualization-tile dark">
  <div class="tile-header">
    <div class="tile-header-title">Company Risk By Quarter</div>
  </div>
  <div class="tile-content">
    <div style="display:block; height:100%" class="fill-available">
      <canvas baseChart
        [datasets]="lineChartData"
        [labels]="lineChartLabels"
        [legend]="lineChartLegend"
        [options]="lineChartOptions"
        [colors]="lineChartColors"
        chartType="line">
      </canvas>
    </div>
  </div>
</div>
